import React, { useEffect, useState } from "react";

function AppDownloadAlert() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div style={styles.banner}>
      <span>
        📱 Please download our application from Play Store for a better
        experience.
      </span>

      <div style={styles.actions}>
        <a
          href="https://play.google.com/store/apps/details?id=com.findmejoinme.findme_joinme"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.button}
        >
          Download
        </a>
        <button onClick={() => setShow(false)} style={styles.close}>
          ✖
        </button>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    background: "#000",
    color: "#fff",
    padding: "12px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 9999,
    gap: "8px",
    boxSizing: "border-box",
  },
  actions: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  button: {
    background: "#34A853",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "5px",
    textDecoration: "none",
    cursor: "pointer",
  },
  close: {
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default AppDownloadAlert;
